import { Avatar, Button, Clickable, Col, Icon, Row, Sidepanel, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SideBarItem } from 'screens/Browse/components';

const Item = ({ user, isAd, follow, removeSuggestion, navigate }) => {
  const { t } = useTranslation();

  return (
    <Col
      pos="relative"
      hasBorder={`1px solid ${theme.GREY_20}`}
      wid="138px"
      noFlex
      ht="166px"
      pad="0 16px 16px"
      centerAll
      start
      between
    >
      <Row wid="120px" between top="8px" pos="absolute" center>
        <Row>
          {isAd && (
            <Row pad="0 4px" bg={theme.PURPLE}>
              <Text c1 bold col="#fff">
                {t('common.ad')}
              </Text>
            </Row>
          )}
        </Row>

        <Clickable onClick={() => removeSuggestion(user)} marg="4px 0 0">
          <Icon type="close" col={theme.GREY_50} dimensions={10.5} />
        </Clickable>
      </Row>

      <Row marg="16px 0 0">
        <Clickable onClick={() => navigate(`/profile/${user.username}`)}>
          <Avatar user={user} />
        </Clickable>
      </Row>

      <Text maxWid="100%" c1 bold marg="8px 0 0" center>
        {user.name}
      </Text>

      <Text c1 med center col={theme.GREY_60} maxWid="100%">
        {!!user.sports?.length && user.sports[0].teamName}
      </Text>

      <Button
        app
        marg="8px 0 0"
        wid="104px"
        text={t('common.follow')}
        small
        onClick={() => follow(user)}
      />
    </Col>
  );
};

const SuggestedAccounts = ({ data, marg }) => {
  const [filtered, setFiltered] = useState(data),
    [openPanel, setOpenPanel] = useState(false),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    { removedSuggestions, following, _id } = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  useEffect(() => {
    setFiltered(
      data?.filter((x) => {
        const filteredFollowing = !following.map((x) => x._id || x).includes(x?._id);
        const filteredRemoved = !removedSuggestions?.includes(x._id);
        const hasName = x.name;
        const isntSelf = x._id !== _id;

        return filteredFollowing && filteredRemoved && hasName && isntSelf;
      })
    );
  }, [removedSuggestions, following, data]);

  function removeSuggestion(user) {
    dispatch({
      type: 'REMOVE_SUGGESTION',
      payload: user._id
    });

    Api.post('/users/removeSuggestion', { userId: user._id });
  }

  async function follow(user) {
    dispatch({
      type: 'FOLLOW',
      payload: user
    });

    const res = await Api.post('/users/follow', { userId: user._id }, 'follow');
  }

  if (!filtered?.length) return null;

  if (isMobile)
    return (
      <Col wid="100%">
        <Row pad="0 16px" between wid="calc(100% - 32px)" center>
          <Text h2>{t('home.accountsToFollow')}</Text>

          {filtered?.length > 6 && (
            <Clickable onClick={() => setOpenPanel(true)}>
              <Text b2 bold>
                {t('common.seeAll')}
              </Text>
            </Clickable>
          )}
        </Row>

        <Row
          start
          style={{ overflowX: 'scroll', overflowY: 'hidden' }}
          hideScrollBar
          wid="100vw"
          marg="8px 0 0"
        >
          {filtered?.slice(0, 6).map((x, i) => (
            <Row marg={`0 0 0 ${i === 0 ? 16 : 8}px`} key={i}>
              <Item
                user={x}
                follow={follow}
                navigate={navigate}
                removeSuggestion={removeSuggestion}
              />
            </Row>
          ))}
        </Row>

        <Sidepanel
          visible={openPanel}
          title={
            <Row wid="calc(100% - 32px)" between center marg="0 0 16px" pad="0 16px">
              <Text h2>{t('home.accountsToFollow')}</Text>

              <Clickable onClick={() => setOpenPanel(false)}>
                <Icon type="close" col={theme.GREY_60} dimensions={14} />
              </Clickable>
            </Row>
          }
          handleClose={() => setOpenPanel(false)}
        >
          <Col marg="24px 0 0" wid="calc(100% - 18px)" noFlex>
            {filtered?.map((x, index) => (
              <SideBarItem
                key={index}
                item={x}
                follow={follow}
                navigate={navigate}
                removeSuggestion={removeSuggestion}
              />
            ))}
          </Col>
        </Sidepanel>
      </Col>
    );

  return (
    <Col wid="100%" marg={marg}>
      <Row between center wid="100%">
        <Text h2>{t('home.accountsToFollow')}</Text>

        {filtered?.length > 4 && (
          <Clickable onClick={() => setOpenPanel(true)}>
            <Text b2 bold>
              {t('common.seeAll')}
            </Text>
          </Clickable>
        )}
      </Row>

      <Row gap="24px" marg="16px 0 0" start>
        {filtered?.slice(0, 6).map((x, index) => (
          <Item
            key={index}
            user={x}
            follow={follow}
            navigate={navigate}
            removeSuggestion={removeSuggestion}
          />
        ))}
      </Row>

      <Sidepanel
        visible={openPanel}
        data={filtered}
        closeModal={() => setOpenPanel(false)}
        wid={500}
        headerHt={88}
        title={
          <Row
            between
            center
            noFlex
            ht={isMobile ? '44px' : '88px'}
            pad={isMobile ? '16px' : '0 24px'}
          >
            <Text h2>{t('home.accountsToFollow')}</Text>

            <Clickable onClick={() => setOpenPanel(false)}>
              <Icon type="close" col={theme.GREY_60} dimensions={14} />
            </Clickable>
          </Row>
        }
      >
        <Col wid="100%" marg="0 0 24px">
          {filtered.map((x, i) => (
            <SideBarItem
              key={i}
              item={x}
              follow={follow}
              navigate={navigate}
              removeSuggestion={removeSuggestion}
            />
          ))}
        </Col>
      </Sidepanel>
    </Col>
  );
};

export default SuggestedAccounts;
